'use es6';

import { PARTNER_CLIENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const PartnerClient = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('partner-client-object-read'),
  objectTypeId: PARTNER_CLIENT_TYPE_ID,
  referenceObjectType: 'PARTNER_CLIENT_PROPERTIES'
});
export default PartnerClient;